import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import MonitoringPlans from './components/MonitoringPlans';
import About from './components/About';
import WorkFlow from './components/WorkFlow';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppBubble from './components/WhatsAppBubble';
import VisitorTracker from './components/VisitorTracker';

const App = () => {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-800 font-sans">
      <VisitorTracker />
      <Header />
      <Hero />
      <Services />
      <MonitoringPlans />
      <About />
      <WorkFlow />
      <Contact />
      <Footer />
      <WhatsAppBubble />
    </div>
  );
};

export default App;
